import { render } from "./CertAlcoholApprovedPending.vue?vue&type=template&id=1b41a3de&scoped=true"
import script from "./CertAlcoholApprovedPending.vue?vue&type=script&lang=js"
export * from "./CertAlcoholApprovedPending.vue?vue&type=script&lang=js"

import "./CertAlcoholApprovedPending.vue?vue&type=style&index=0&id=1b41a3de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b41a3de"]])

export default __exports__